import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { GetUrlApi } from '../Globales/VariableGlobales';
import { GetPrecioFormateado, Logout } from '../Globales/VariableGlobales';
import { GetUserCookie } from '../Globales/Utilidades';
import swal from 'sweetalert';

import { PopupEditarGrupo } from '../MantenedorGrupos/PopupEditarGrupo';

import { PopupAgregarGrupo } from '../MantenedorGrupos/PopupAgregarGrupo';

export class MantenedorGrupos extends Component {
    static displayName = MantenedorGrupos.name;

    StateInicial = {
        grupos: [],
        //-----estados popup
        activarAgregarGrupo: false,
        activarEditarGrupo: false,
        //------estados popup

        //------estados crear usuario
        sucursales: [],
        grupoSeleccionado: {},
        //------fin estados editar usuario
    }

    constructor(props) {
        super(props);
        this.state = this.StateInicial;
        this.TraerGrupos();
    }

    //-------->INICIO FUNCIONES CRUD
    async TraerGrupos() {
        const sucursalUsuario = GetUserCookie().SucursalID;
        var respuesta = await fetch(GetUrlApi() + '/api/Grupos?sucursalID=' + sucursalUsuario, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if (respuesta.ok) {
            var datos = await respuesta.json();
            this.setState({ grupos: datos });
        }
    }


    //-------->FIN FUNCIONES CRUD

    Estilos = {

        ButtonStyleS:
        {
            'borderRadius': '10px',
            'height': '48px',
            'width': '55px',
            'border-color': 'cadetblue',
            'backgroundColor': '#28a745',
            'margin-top': '0.5%',
            'margin-right': '1%',
            'margin-left': '2%'
        },
        BtnOpt:
        {
            'marginRight': '10px',
            'border-radius': '5px',
            'background': '#7fc1a7',
            'color': 'white'
        },
        BtnOpt1:
        {
            'border-radius': '5px',
            'background': '#7fc1a7',
            'color': 'white'
        },
        TableStyle:
        {
            'margin-left': '3%'
        },
        Space:
        {
            'padding-right': '5px'
        },
        StylePopUp:
        {
            'position': 'relative',
            'background': 'rgb(255, 255, 255)',
            'width': '50%',
            'margin': 'auto',
            'border': '1px solid rgb(187, 187, 187)',
            'padding': '5px',
            'border-radius': '7px'
        },
        BtnAddUser:
        {
            'margin-bottom': '1%',
            'margin-left': '3%'
        },
    }



    //------->inicio onclick
   

    ClickEditarGrupo(grupo) {
        this.setState({ grupoSeleccionado: grupo, activarEditarGrupo: true });
    }


    async ClickInhabilitarGrupo(id) {
        swal({
            title: "¿Está seguro que desea dehabilitar este grupo?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                var respuesta = await fetch(GetUrlApi() + '/api/Grupos/' + id, {
                    method: 'delete',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                if (respuesta.ok) {
                    swal("Grupo deshabilitado", {
                        icon: "success",
                    });
                    this.Recargar();
                }
            }
        });
    }

    ClickCrearGrupo() {
        this.setState({ activarAgregarGrupo: true });
    }

    //------->fin onclick


    Recargar() {
        this.setState(this.StateInicial);
        this.TraerGrupos();
    }

    CerrarModalMaster() {
        this.setState({ activarAgregarGrupo: false, activarEditarGrupo: false });
    }

    render() {
        return (
            <div  >
                {
                    (this.state.activarAgregarGrupo) ? (
                        <PopupAgregarGrupo
                            Recargar={this.Recargar.bind(this)}
                            CerrarModalMaster={this.CerrarModalMaster.bind(this)}
                        />
                    ) : (null)
                }
                {
                    (this.state.activarEditarGrupo) ? (
                        <PopupEditarGrupo
                            Recargar={this.Recargar.bind(this)}
                            CerrarModalMaster={this.CerrarModalMaster.bind(this)}
                            grupoSeleccionado={this.state.grupoSeleccionado}
                        />
                    ) : (null)
                }

                <div className="alert alert-info" role="alert">
                    <strong> Grupos</strong>

                </div>

                <button onClick={() => { this.ClickCrearGrupo() }} type="button" className="btn btn-info" style={this.Estilos.BtnAddUser}>
                    <i style={this.Estilos.Space} class="fa fa-plus-circle" aria-hidden="true"></i>
                    Agregar Grupo
                        </button>


                <table className="table" style={this.Estilos.TableStyle}>
                    <thead>
                        <tr>
                            <td><b>Descripcion</b></td>
                            <td><b>Familia</b></td>
                            <td><b>Sucursal</b></td>
                            <td><b></b></td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.grupos.map((item, i) => {
                                return (
                                    <tr>
                                        <td>{item.descripcion}</td>
                                        <td>{item.familia.descripcion}</td>
                                        <td>{item.sucursal.descripcion}</td>
                                        <td>
                                            <button style={this.Estilos.BtnOpt} onClick={() => { this.ClickEditarGrupo(item) }} data-toggle="tooltip" data-placement="right" title="Editar" >
                                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                                            <button style={this.Estilos.BtnOpt1} onClick={() => { this.ClickInhabilitarGrupo(item.id) }} data-toggle="tooltip" data-placement="right" title="Eliminar" >
                                                <i class="fa fa-trash " aria-hidden="true"></i></button>

                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>

            </div>
        );
    }


}
